import {
  ProjectRole,
  SystemRole,
  type ProjectRoleType,
  type SystemRoleType,
} from '@/core/types/models/RoleTypes';

export type EffectiveUserRole = ProjectRoleType | SystemRoleType;

type ProjectRoleProjectMember = {
  userId?: string | null;
  role?: string | null;
};

type ProjectRoleProject = {
  id?: string | null;
  members?: ReadonlyArray<ProjectRoleProjectMember> | null;
};

export interface ResolveEffectiveUserRoleOptions {
  projects: ReadonlyArray<ProjectRoleProject>;
  selectedProjectId: string | null | undefined;
  systemRole: SystemRoleType | null | undefined;
  userId: string | null | undefined;
}

export function resolveEffectiveUserRole({
  projects,
  selectedProjectId,
  systemRole,
  userId,
}: ResolveEffectiveUserRoleOptions): EffectiveUserRole {
  if (systemRole === SystemRole.Administrator) {
    return SystemRole.Administrator;
  }

  if (!selectedProjectId || !userId) {
    return SystemRole.User;
  }

  const selectedProject = projects.find((project) => project.id === selectedProjectId);
  const member = selectedProject?.members?.find((candidate) => candidate.userId === userId);

  if (member?.role && Object.values(ProjectRole).includes(member.role as ProjectRoleType)) {
    return member.role as ProjectRoleType;
  }

  return SystemRole.User;
}

export function isProjectViewerRole(role: EffectiveUserRole | null | undefined): boolean {
  return role === ProjectRole.ProjectViewer;
}

export function isSystemAdminRole(role: EffectiveUserRole | null | undefined): boolean {
  return role === SystemRole.Administrator;
}

export function isProjectOwnerOrAdminRole(role: EffectiveUserRole | null | undefined): boolean {
  return role === SystemRole.Administrator || role === ProjectRole.ProjectOwner;
}
